export default __webpack_public_path__ + "static/media/YouTubeClone.8eea245d.gif";